import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { ArrowUpRight, Clock } from "lucide-react";

const ToyCard = ({ toy, index = 0 }) => {
  const { t, lang } = useLanguage();
  const species = lang === "fr" ? toy.species_fr : toy.species_en;
  const placeholder = lang === "en" ? "/coming-soon-en.svg" : "/coming-soon.svg";
  const swap = (src) =>
    src && (src.endsWith("/coming-soon.svg") || src.endsWith("/coming-soon-en.svg")) ? placeholder : src;
  const image = swap(toy.gallery?.[0]) || placeholder;

  return (
    <Link
      to={`/toy/${toy.id}`}
      data-testid={`toy-card-${toy.id}`}
      className="group block hover-lift animate-fade-up"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="relative overflow-hidden rounded-2xl border border-border bg-cream/30">
        <div className="aspect-[4/5] overflow-hidden">
          <img
            src={image}
            alt={toy.name}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>
        {!toy.available && (
          <div
            data-testid={`sold-banner-${toy.id}`}
            className="absolute top-0 left-0 w-32 h-32 overflow-hidden pointer-events-none"
            aria-label={t.common.sold}
          >
            <div
              className="absolute top-[26px] left-[-46px] w-[180px] py-1.5 text-center text-xs font-medium uppercase tracking-[0.3em] text-background shadow-md"
              style={{
                transform: "rotate(-45deg)",
                backgroundColor: "#C0392B",
              }}
            >
              {t.common.sold}
            </div>
          </div>
        )}
        <div className="absolute bottom-4 right-4 w-10 h-10 rounded-full bg-background/95 backdrop-blur grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <ArrowUpRight size={16} strokeWidth={1.5} className="text-terracotta" />
        </div>
      </div>

      <div className="pt-5 px-1 space-y-2">
        <div className="flex items-baseline justify-between gap-4">
          <h3 className="font-serif-display text-2xl text-ink leading-none">{toy.name}</h3>
          <span className="font-body text-terracotta text-lg font-medium">
            {t.common.currency}{toy.price} <span className="text-xs text-camel">{t.common.currencyCode}</span>
          </span>
        </div>
        <div className="flex items-center justify-between text-xs">
          <span className="font-body uppercase tracking-widest text-muted-foreground">{species}</span>
          <span className="flex items-center gap-1 text-camel">
            <Clock size={12} strokeWidth={1.5} /> {toy.creation_hours}{t.common.hours}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ToyCard;
